import { useEffect } from "react";

// https://atomizedobjects.com/blog/react/add-event-listener-react-hooks/
// https://www.npmjs.com/package/use-add-event

/**
 * useEvent
 * @description A react hook for functional components add events
 * @example
  const handleResize = (e) => { ... };
  useEvent('resize', handleResize);
 */

export const useEvent = <T extends Event>(
  event: string,
  handler: (event: T) => void,
  passive: boolean = false,
): void => {
  useEffect(() => {
    // Type assertion here since we know the event type matches T
    const eventHandler = ((e: Event) => handler(e as T)) as EventListener;

    window.addEventListener(event, eventHandler, passive);

    return function cleanup() {
      window.removeEventListener(event, eventHandler);
    };
  });
};
